import { createContext, useContext } from "react";
interface TokenContextValue {
    accessToken: string;
    residentId: string;
    facilityId: string;
    userId: string;
}
const TokenContext = createContext<TokenContextValue | null>(null);
export { TokenContext };
export const TokenProvider = TokenContext.Provider;
export function useChatContext(): TokenContextValue {
    const ctx = useContext(TokenContext);
    if (!ctx) throw new Error("useChatContext must be used within TokenProvider");
    return ctx;
}
